import axios from 'axios';
import Store from '$common/utils/store';
import JsCrypto from '$proDirname/app/service/util-service/js-crypto';
import Nprogress from "nprogress";

const domain = 'lifekh.com';
const domainPrefix = 'boss-merchant';
//  当前环境
export const env = window.location.host.indexOf(domain) !== -1 && (window.location.host.replace(eval(`/${domainPrefix}|-|\.${domain}/g`), '') || 'sit') || '';
export const host = window.location.host.indexOf(domain) !== -1 && window.location.host || `https://${domainPrefix}${env && `-${env}` || ''}.${domain}`;
const jsCrypto = JsCrypto(1, true);
// 创建axios实例
const basicApi = axios.create();
// 设置缺省头部字段
basicApi.defaults = Object.assign(basicApi.defaults, {
  headers: {
    appId: 'SuperMerchant',
    appNo: 23,
    'Content-Type': 'application/json',
    TermTyp: 'WEB', // go 3.0要求字段,用于描述客户端类型
    appVersion: '1.0'
  },
  withCredentials: true,
  crossDomain: true,
  timeout: 10e4 // 10秒超时
})
//  将路径和参数转换格式
const getEggQuery = query => {
  const apiUrl = query.url.replace(/\/api\//, '/');
  const apiQuery = encodeURIComponent(JSON.stringify({
    apiUrl,
    apiData: JSON.parse(JSON.stringify(query.data))
  }));
  const httpQuery = Object.assign({}, {
    apiQuery
  });
  return httpQuery;
}
const getResult = res => {
  let isShowResult = false;
  if (localStorage.getItem('show-get-result')) {
    isShowResult = true;
  }
  if (window.location.href.indexOf('show-get-result') !== -1) {
    isShowResult = true;
    localStorage.setItem('show-get-result', isShowResult);
  }
  if (window.location.href.indexOf('show-get-result=0') !== -1) {
    isShowResult = false;
    localStorage.removeItem('show-get-result');
  }
  if (isShowResult) {
    console.log('\n\n===================== Response Start =====================');
    console.log(res);
    console.log('===================== Response End =====================');
  }
  return res;
}
let currentApiAxios = {};
const base_api = function (...args) {
  let isGet = false;
  const params = args[0];
  if ((`${encodeURIComponent(JSON.stringify(params.data))}${params.url}`).length < 500) {
    isGet = true;
  }
  const headers = Object.assign(basicApi.defaults?.headers, {
    'dark-flower': MD5(Cookies.get('scenes') + jsCrypto.CryptoJSKeys),
    authorization: Store.loadObject('access_token'),
    deviceid: Store.loadObject('deviceId'),
    operatorno: Store.loadObject('operator_no'),
    'Accept-Language': getLang()
  });
  if (params.responseType) {
    headers.responseType = params.responseType;
    Object.keys(params.headers).forEach(e => {
      headers[e] = params.headers[e]
    });
  }
  if (isGet) {
    return new Promise((resolve, reject) => {
      const apiUrl = params.url.replace(/\/api\//, '/');
      currentApiAxios[apiUrl] = {
        query: {
          apiUrl,
          apiData: JSON.parse(JSON.stringify(params.data))
        },
        reject,
        resolve
      };
      const __currentApiAxios = currentApiAxios;
      currentApiAxios = {};
      axios.get(`${process.env.NODE_ENV === 'development' && '/api' || ''}/view/boss-api/batch`, {
        params: {
          apiQueryList: encodeURIComponent(JSON.stringify(Object.keys(__currentApiAxios).map(e => __currentApiAxios[e].query)))
        },
        headers,
        responseType: params.responseType || ''
      }).then(resList => {
        try {
          // 如果返回的是 exec 流，则直接返回
          resList.data = JSON.parse(decodeURIComponent(jsCrypto.decrypt(resList.data)));
        } catch (err) {
          if (!Array.isArray(resList.data)) {
            resolve(resList);
            return;
          }
        }
        if (resList.data.length === 1 && !!(resList.data[0].rspCd !== '00000' || resList.data[0].rspInf !== 'success')) {
          const ret = getResult(Object.assign({}, resList, {
            data: resList.data[0]
          }));
          Object.keys(__currentApiAxios).forEach(__key => __currentApiAxios[__key].resolve(ret));
        } else {
          for (let i = 0, len = resList.data.length; i < len; i++) {
            __currentApiAxios[resList.data[i].api].resolve(getResult(Object.assign({}, resList, {
              data: resList.data[i]
            })));
          }
        }
      }).catch(resList => {
        try {
          resList.data = JSON.parse(decodeURIComponent(jsCrypto.decrypt(resList.data)))
        } catch (err) {
          if (!Array.isArray(resList.data)) {
            resolve(resList);
            return;
          }
        }
        Object.keys(__currentApiAxios).forEach(e => __currentApiAxios[e].reject(resList));
      });
    })
  } else {
    return axios.post(`${process.env.NODE_ENV === 'development' && '/api' || ''}/view/boss-api`, getEggQuery(params), {
      headers,
      responseType: params.responseType || ''
    }).then(res => {
      try {
        res.data = JSON.parse(decodeURIComponent(jsCrypto.decrypt(res.data)))
      } catch (err) {
      }
      return getResult(res)
    })
  }
}

// 获取语言
function getLang() {
  const lang = $vm.$i18n.locale;
  const langMap = {
    zh: 'zh-CN',
    en: 'en-US',
    cb: 'cb',
    km: 'km-KH'
  }
  return langMap[lang];
}

// 网络异常处理
const errorManage = (error) => {
  // TODO 网络异常追加国际化处理,以及更详细的异常处理提示
  $vm.$message.error($vm.$t('common.network_error'));
  return {
    rspCd: '30000', // 与后端约定好的占位码,标识前端网络异常
    rspInf: $vm.$message.error($vm.$t('common.network_error')),
    data: {
      ...error
    },
    rspType: ''
  }
}
// 请求拦截器
axios.interceptors.request.use(
  config => {
    Nprogress.start()
    config.headers['Accept-Language'] = getLang() // 设置头字段
    return config;
  }, error => { // TODO 请求错误处理
    return Promise.reject(error)
  });
// 响应拦截器
axios.interceptors.response.use(res => {
  Nprogress.done();
  return res
}, error => Promise.reject(errorManage(error)));

/**
 * @description 处理后端响应的异常信息
 * @param {Object} resData 后端约定的响应对象
 */
const rspInfManage = (resData) => {
  const {
    rspCd,
    rspInf,
    data,
    rspType
  } = resData
  // session异常码
  const sessionInValidCodes = ['O1048', 'O1049', 'O1002']
  if (`${rspType}` === '1') { // 占位符rspType == 1处理
    // 先去rspInf中获取占位标识key,再到data中获取值,最后替换回rspInf中
    try {
      const key = rspInf.replace(/^[^{]*{([^}]+)}[^}]+$/, '$1')
      const infoLabel = data[key]
      const msg = rspInf.replace(/{[^}]+}/i, infoLabel)
      $vm.$message.error(msg);
    } catch (error) {
      if (rspInf) {
        $vm.$message.closeAll()
        $vm.$message.error(rspInf);
      }
    }
  } else if (/^[A-Za-z]\d{4}$/.test(`${rspCd}`)) { // 业务自定义异常码处理 /^[A-Za-z]\d{4}$/i 例:T1000,B1000
    $vm.$message.closeAll()
    $vm.$message.error(rspInf)
    // session 异常场景下,自动控制缓存标识并让路由刷新,路由会根据缓存标识isSessionValid判断是否跳回登录页
    // 因为boss后端是通过login.do的请求来写入sessionId服务端缓存的,所以必须回到登录页走正常的登录流程
    if (sessionInValidCodes.indexOf(rspCd) > -1) {
      // TODO 处理多个未登录响应并发逻辑
      // 目前暂时解决方案是session后刷新,路由在监听到session标识失效会自动跳回登录页
      $vm.$router.replace('/login');
    }
  } else if (`${rspCd}` !== '00000' && `${rspCd}` !== 'success') { // 响应逻辑异常
    $vm.$message.closeAll()
    $vm.$message.error(rspInf)
  }
}
const post_funcCallback = (res, isBlockException) => {
  // 处理错误信息
  // 状态码200下,存在rspCd的响应才去处理异常信息
  // TODO 前后端约定可枚举的content-type来分情况处理
  if (!isBlockException && res.data && !!res.data.rspCd) {
    rspInfManage(res.data);
  } else if (res?.data?.config?.headers && res?.data?.config?.crossDomain && res?.data?.config?.method) {
    $vm.$message.error('Not Found!');
  }
}
/**
 * @description 调用后端api的主入口
 * @param {Object} params 请求的参数
 * @param {String} url 请求的url
 * @param {Object} config 对于请求器的配置<br/>
 *  isBlockException false 是否拦截后端异常
 */
const post_func = (params = {}, url, config = {}) => {
  return base_api({
    method: 'post',
    url: process.env.NODE_ENV === 'development' ? '/api/' + url : /http(s)?:\/\/.+/.test(url) ? url : host + '/' + url,
    data: params,
    headers: config?.headers ?? {}
  }).then((res) => {
    post_funcCallback(res, !!(config?.isBlockException));
    return res.data;
  })
}
const get_upload_url = apiUrl => `${process.env.NODE_ENV === 'development' && '/api' || ''}/view/boss-api/upload?api=${encodeURIComponent(apiUrl)}`
export {
  base_api,
  errorManage,
  rspInfManage,
  post_funcCallback,
  post_func,
  get_upload_url
};
